export const EMPLOYEE_LIST_REQUEST = 'EMPLOYEE_LIST_REQUEST';
export const EMPLOYEE_LIST_SUCCESS = 'EMPLOYEE_LIST_SUCCESS';
export const EMPLOYEE_LIST_FAIL = 'EMPLOYEE_LIST_FAIL';